const getType = (val: any) =>
  Object.prototype.toString.call(val).slice(8, -1).toLowerCase();

export default getType;
